//TODAY TIMING LIST
export const USER_TIMING_TODAY_LIST_REQUEST = 'USER_TIMING_TODAY_LIST_REQUEST';
export const USER_TIMING_TODAY_LIST_SUCCESS = 'USER_TIMING_TODAY_LIST_SUCCESS';
export const USER_TIMING_TODAY_LIST_FAIL = 'USER_TIMING_TODAY_LIST_FAIL';

//TODAY DASHBOARD TIMING LIST
export const USER_DASHBOARD_TIMING_TODAY_LIST_REQUEST = 'USER_DASHBOARD_TIMING_TODAY_LIST_REQUEST';
export const USER_DASHBOARD_TIMING_TODAY_LIST_SUCCESS = 'USER_DASHBOARD_TIMING_TODAY_LIST_SUCCESS';
export const USER_DASHBOARD_TIMING_TODAY_LIST_FAIL = 'USER_DASHBOARD_TIMING_TODAY_LIST_FAIL';

//PREV TIMING LIST
export const USER_TIMING_PREV_LIST_REQUEST = 'USER_TIMING_PREV_LIST_REQUEST';
export const USER_TIMING_PREV_LIST_SUCCESS = 'USER_TIMING_PREV_LIST_SUCCESS';
export const USER_TIMING_PREV_LIST_FAIL = 'USER_TIMING_PREV_LIST_FAIL';

//MONTH TIMING LIST
export const USER_TIMING_MONTH_LIST_REQUEST = 'USER_TIMING_MONTH_LIST_REQUEST';
export const USER_TIMING_MONTH_LIST_SUCCESS = 'USER_TIMING_MONTH_LIST_SUCCESS';
export const USER_TIMING_MONTH_LIST_FAIL = 'USER_TIMING_MONTH_LIST_FAIL';

//RANGE_DASHBOARD_LIST
export const USER_RANGE_DASHBOARD_LIST_REQUEST = 'USER_RANGE_DASHBOARD_LIST_REQUEST';
export const USER_RANGE_DASHBOARD_LIST_SUCCESS = 'USER_RANGE_DASHBOARD_LIST_SUCCESS';
export const USER_RANGE_DASHBOARD_LIST_FAIL = 'USER_RANGE_DASHBOARD_LIST_FAIL';

//WEEK_DASHBOARD_LIST
export const USER_WEEK_DASHBOARD_LIST_REQUEST = 'USER_WEEK_DASHBOARD_LIST_REQUEST';
export const USER_WEEK_DASHBOARD_LIST_SUCCESS = 'USER_WEEK_DASHBOARD_LIST_SUCCESS';
export const USER_WEEK_DASHBOARD_LIST_FAIL = 'USER_WEEK_DASHBOARD_LIST_FAIL';

//USER_RANGE_WISE_TIME_LIST
export const USER_RANGE_WISE_TIME_LIST_REQUEST = 'USER_RANGE_WISE_TIME_LIST_REQUEST';
export const USER_RANGE_WISE_TIME_LIST_SUCCESS = 'USER_RANGE_WISE_TIME_LIST_SUCCESS';
export const USER_RANGE_WISE_TIME_LIST_FAIL = 'USER_RANGE_WISE_TIME_LIST_FAIL';